import { v4 } from 'uuid';
import { AnalyticsAction, SIGNUP_AUTH_SUCCESS } from '../../constants/analytics';
import { CookieName } from '../../constants/cookie';
import { EventId } from '../../types/analytics';
import { DispatchThunk } from '../../types/common';
import { ANALYTICS_ENVIRONMENT } from '../../utils/analytics';
import { getCookie } from '../../utils/cookie';
import * as facebook from '../../utils/facebook';
import { getAppTrack, getAppVersion } from '../selectors/config';

export const EVENT_ID_EVENTS = [...facebook.SUBSCRIBE_EVENTS, SIGNUP_AUTH_SUCCESS];

type AnalyticsThunk = (event: string, properties?: any, options?: any) => DispatchThunk;

function handleAnalyticsAction(
  action: AnalyticsAction,
  event: string,
  properties: any = {},
  options: any = {},
): DispatchThunk {
  return (dispatch, getState) => {
    const state = getState();
    const version = getAppVersion(state);
    const appTrack = getAppTrack(state);

    const needsEventId = EVENT_ID_EVENTS.includes(event);
    const pixelProps = { ...(needsEventId && { event_id: v4() }) };
    const props = {
      ...(properties || {}),
      ...pixelProps,
      hashedSessionId: getCookie({ name: CookieName.SESSION_ID, isJSON: false }),
      environment: { ...ANALYTICS_ENVIRONMENT, version, track: appTrack },
    };

    globalThis.analytics?.[action]?.(event, props, options);
    if (action === AnalyticsAction.PAGE || action === AnalyticsAction.TRACK) {
      facebook[action]?.({
        event,
        ...(needsEventId && { eventId: pixelProps as EventId }),
      });
    }
    dispatch({
      type: `APP_ANALYTICS_${action.toUpperCase()}`,
      event,
      properties,
      options,
    });
  };
}

export const page: AnalyticsThunk = (...args) => {
  return dispatch => dispatch(handleAnalyticsAction(AnalyticsAction.PAGE, ...args));
};

export const track: AnalyticsThunk = (...args) => {
  return dispatch => dispatch(handleAnalyticsAction(AnalyticsAction.TRACK, ...args));
};

export const identify: AnalyticsThunk = (...args) => {
  return dispatch => dispatch(handleAnalyticsAction(AnalyticsAction.IDENTIFY, ...args));
};

export function tryToIdentify(analytics: { userId: string | null } | undefined): DispatchThunk {
  return dispatch => {
    if (analytics?.userId) {
      dispatch(identify(analytics.userId));
    }
  };
}
